<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    //transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 500px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    max-width: 98vw;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    margin: 20px 0;
    padding: 0;
    min-height: 0;

    &.scroll-body {
        max-height: 35vh;
        overflow: auto;
    }
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

// .modal-enter {
//     opacity: 0;
// }

// .modal-leave-active {
//     opacity: 0;
// }
</style>

<template>
    <transition class="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div
                    class="modal-container"
                    :style="{
                        width: width,
                        height: height,
                    }"
                    @keyup.enter="onEnter"
                >
                    <div class="modal-header">
                        <slot name="header"> Default Header </slot>
                    </div>

                    <div
                        class="modal-body"
                        :class="{ 'scroll-body': scrollBody }"
                    >
                        <slot name="body"> Default Body </slot>
                    </div>

                    <div class="modal-footer" v-if="!noFooter">
                        <slot name="footer">
                            <div v-if="!jsonViewEdit">
                                <Button outline @click="$emit('cancel')">{{
                                    $t('cancel')
                                }}</Button>
                                <Button
                                    @click="$emit('ok')"
                                    :disabled="confirmDisabled"
                                    v-show="!hideOk"
                                >
                                    {{ $t('confirm') }}
                                </Button>
                            </div>
                            <div v-if="jsonViewEdit">
                                <Button outline @click="$emit('cancel')">{{
                                    $t('cancel')
                                }}</Button>
                                <Button
                                    @click="$emit('validate')"
                                    :disabled="confirmDisabled"
                                    v-show="!hideOk"
                                >
                                    {{ $t('validateJson') }}
                                </Button>
                                <Button
                                    @click="$emit('ok')"
                                    :disabled="confirmDisabled"
                                    v-show="!hideOk"
                                >
                                    {{ $t('save') }}
                                </Button>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        confirmDisabled: Boolean, // disable confirm button
        noFooter: Boolean, // Whether or not there will be a footer with ok and cancel buttons
        hideOk: Boolean, // If true, the confirm button will not display in the footer
        scrollBody: Boolean, // Whether or not to limit this modal's  content to be a scrollable body
        width: String,
        height: String,
        jsonViewEdit: Boolean,
    },

    methods: {
        // Enter key should only confirm when the confirm button is enabled
        onEnter() {
            if (!this.confirmDisabled) {
                this.$emit('ok');
            }
        },
    },
};
</script>
